import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResource = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 47,
	viewBox: "0 0 45 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7319 44.8064C41.7319 44.7229 42.1123 44.6534 42.5878 44.6534C43.0633 44.6534 43.4436 44.7229 43.4436 44.8064C43.4436 44.8899 43.0633 44.9595 42.5878 44.9595C42.1123 44.9595 41.7319 44.8899 41.7319 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3024 44.8064C38.3024 44.7229 38.6827 44.6534 39.1582 44.6534C39.6337 44.6534 40.0141 44.7229 40.0141 44.8064C40.0141 44.8899 39.6337 44.9595 39.1582 44.9595C38.6827 44.9595 38.3024 44.8899 38.3024 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8657 44.8064C34.8657 44.7229 35.2461 44.6534 35.7216 44.6534C36.197 44.6534 36.5774 44.7229 36.5774 44.8064C36.5774 44.8899 36.197 44.9595 35.7216 44.9595C35.2461 44.9595 34.8657 44.8899 34.8657 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4684 44.8064C31.4684 44.7229 31.8488 44.6534 32.3242 44.6534C32.7997 44.6534 33.1801 44.7229 33.1801 44.8064C33.1801 44.8899 32.7997 44.9595 32.3242 44.9595C31.8488 44.9595 31.4684 44.8899 31.4684 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0066 44.8064C28.0066 44.7229 28.3938 44.6534 28.8692 44.6534C29.3447 44.6534 29.7251 44.7229 29.7251 44.8064C29.7251 44.8899 29.3379 44.9595 28.8692 44.9595C28.4006 44.9595 28.0066 44.8899 28.0066 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5735 44.8064C24.5735 44.7229 24.9607 44.6534 25.4361 44.6534C25.9116 44.6534 26.292 44.7229 26.292 44.8064C26.292 44.8899 25.9048 44.9595 25.4361 44.9595C24.9675 44.9595 24.5735 44.8899 24.5735 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1439 44.8064C21.1439 44.7229 21.5311 44.6534 22.0066 44.6534C22.482 44.6534 22.8624 44.7229 22.8624 44.8064C22.8624 44.8899 22.4752 44.9595 22.0066 44.9595C21.5379 44.9595 21.1439 44.8899 21.1439 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7145 44.8064C17.7145 44.7229 18.1016 44.6534 18.5771 44.6534C19.0526 44.6534 19.433 44.7229 19.433 44.8064C19.433 44.8899 19.0458 44.9595 18.5771 44.9595C18.1084 44.9595 17.7145 44.8899 17.7145 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2849 44.8064C14.2849 44.7229 14.6721 44.6534 15.1408 44.6534C15.6094 44.6534 16.0034 44.7229 16.0034 44.8064C16.0034 44.8899 15.6162 44.9595 15.1408 44.9595C14.6653 44.9595 14.2849 44.8899 14.2849 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8553 44.8064C10.8553 44.7229 11.2425 44.6534 11.7112 44.6534C12.1799 44.6534 12.5738 44.7229 12.5738 44.8064C12.5738 44.8899 12.1867 44.9595 11.7112 44.9595C11.2357 44.9595 10.8553 44.8899 10.8553 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.4259 44.8064C7.4259 44.7229 7.81308 44.6534 8.28176 44.6534C8.75044 44.6534 9.1444 44.7229 9.1444 44.8064C9.1444 44.8899 8.75723 44.9595 8.28176 44.9595C7.80628 44.9595 7.4259 44.8899 7.4259 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.9928 44.8064C3.9928 44.7229 4.37997 44.6534 4.84865 44.6534C5.31733 44.6534 5.71129 44.7229 5.71129 44.8064C5.71129 44.8899 5.32412 44.9595 4.84865 44.9595C4.37318 44.9595 3.9928 44.8899 3.9928 44.8064Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58228 43.8319C1.66379 43.8319 1.73171 44.2284 1.73171 44.7084V44.8405L1.58228 44.6945C1.99662 44.6945 2.30907 44.764 2.30907 44.8405C2.30907 44.9171 1.99662 44.9797 1.58228 44.9936H1.43964V44.7084C1.39888 44.1936 1.4668 43.8319 1.58228 43.8319Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 40.2849C1.66588 40.2849 1.73381 40.6814 1.73381 41.1614C1.73381 41.6413 1.66588 42.0448 1.58437 42.0448C1.50286 42.0448 1.43494 41.6483 1.43494 41.1614C1.43494 40.6744 1.4689 40.2849 1.58437 40.2849Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 36.7728C1.66588 36.7728 1.73381 37.1624 1.73381 37.6493C1.73381 38.1362 1.66588 38.5258 1.58437 38.5258C1.50286 38.5258 1.43494 38.1362 1.43494 37.6493C1.43494 37.1624 1.4689 36.7728 1.58437 36.7728Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 33.2585C1.66588 33.2585 1.73381 33.6481 1.73381 34.135C1.73381 34.622 1.66588 35.0115 1.58437 35.0115C1.50286 35.0115 1.43494 34.622 1.43494 34.135C1.43494 33.6481 1.4689 33.2585 1.58437 33.2585Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 29.7465C1.66588 29.7465 1.73381 30.136 1.73381 30.623C1.73381 31.1099 1.66588 31.4995 1.58437 31.4995C1.50286 31.4995 1.43494 31.1099 1.43494 30.623C1.43494 30.136 1.4689 29.7465 1.58437 29.7465Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 26.2318C1.66588 26.2318 1.73381 26.6213 1.73381 27.1083C1.73381 27.5952 1.66588 27.9848 1.58437 27.9848C1.50286 27.9848 1.43494 27.5952 1.43494 27.1083C1.43494 26.6213 1.4689 26.2318 1.58437 26.2318Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 22.7211C1.66588 22.7211 1.73381 23.1106 1.73381 23.5976C1.73381 24.0845 1.66588 24.4741 1.58437 24.4741C1.50286 24.4741 1.43494 24.0845 1.43494 23.5976C1.43494 23.1106 1.4689 22.7211 1.58437 22.7211Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 19.2077C1.66588 19.2077 1.73381 19.5972 1.73381 20.0842C1.73381 20.5711 1.66588 20.9607 1.58437 20.9607C1.50286 20.9607 1.43494 20.5711 1.43494 20.0842C1.43494 19.5972 1.4689 19.2077 1.58437 19.2077Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 15.6867C1.66588 15.6867 1.73381 16.0832 1.73381 16.5701C1.73381 17.0571 1.66588 17.4466 1.58437 17.4466C1.50286 17.4466 1.43494 17.0501 1.43494 16.5701C1.43494 16.0902 1.4689 15.6867 1.58437 15.6867Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 12.1742C1.66588 12.1742 1.73381 12.5707 1.73381 13.0576C1.73381 13.5446 1.63192 13.9202 1.58437 13.9202C1.53682 13.9202 1.43494 13.5237 1.43494 13.0437C1.43494 12.5638 1.4689 12.1742 1.58437 12.1742Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 8.66037C1.66588 8.66037 1.73381 9.05688 1.73381 9.54382C1.73381 10.0308 1.63192 10.4412 1.58437 10.4412C1.53682 10.4412 1.43494 10.0447 1.43494 9.56469C1.43494 9.0847 1.4689 8.66037 1.58437 8.66037Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58437 5.14833C1.66588 5.14833 1.73381 5.54484 1.73381 6.03178C1.73381 6.51872 1.66588 6.90826 1.58437 6.90826C1.50286 6.90826 1.43494 6.51176 1.43494 6.03178C1.43494 5.5518 1.4689 5.14833 1.58437 5.14833Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.8066 1.89962C1.8066 1.94136 1.70471 1.9831 1.54848 2.01093L1.65716 1.89962C1.6869 2.10221 1.70053 2.30694 1.69792 2.51178C1.69792 2.99872 1.62999 3.39522 1.54848 3.39522C1.46697 3.39522 1.39905 2.99872 1.39905 2.51178C1.39983 2.30705 1.41345 2.10257 1.4398 1.89962V1.77441H1.52131C1.70471 1.81614 1.8066 1.85789 1.8066 1.89962Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.23766 1.89964C5.23766 1.98312 4.85049 2.05268 4.38181 2.05268C3.91313 2.05268 3.51917 1.98312 3.51917 1.89964C3.51917 1.81617 3.90634 1.7466 4.38181 1.7466C4.85728 1.7466 5.23766 1.81617 5.23766 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66763 1.89964C8.66763 1.98312 8.28725 2.05268 7.81178 2.05268C7.33631 2.05268 6.95593 1.98312 6.95593 1.89964C6.95593 1.81617 7.33631 1.7466 7.81178 1.7466C8.28725 1.7466 8.66763 1.81617 8.66763 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0972 1.89964C12.0972 1.98312 11.7168 2.05268 11.2413 2.05268C10.7659 2.05268 10.3855 1.98312 10.3855 1.89964C10.3855 1.81617 10.7659 1.7466 11.2413 1.7466C11.7168 1.7466 12.0972 1.81617 12.0972 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5266 1.89964C15.5266 1.98312 15.1463 2.05268 14.6708 2.05268C14.1953 2.05268 13.8149 1.98312 13.8149 1.89964C13.8149 1.81617 14.1953 1.7466 14.6708 1.7466C15.1463 1.7466 15.5266 1.81617 15.5266 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9562 1.89964C18.9562 1.98312 18.5758 2.05268 18.1004 2.05268C17.6249 2.05268 17.2445 1.98312 17.2445 1.89964C17.2445 1.81617 17.6249 1.7466 18.1004 1.7466C18.5758 1.7466 18.9562 1.81617 18.9562 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3893 1.89964C22.3893 1.98312 22.0089 2.05268 21.5335 2.05268C21.058 2.05268 20.6776 1.98312 20.6776 1.89964C20.6776 1.81617 21.058 1.7466 21.5335 1.7466C22.0089 1.7466 22.3893 1.81617 22.3893 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8189 1.89964C25.8189 1.98312 25.4385 2.05268 24.963 2.05268C24.4876 2.05268 24.1072 1.98312 24.1072 1.89964C24.1072 1.81617 24.4876 1.7466 24.963 1.7466C25.4385 1.7466 25.8189 1.81617 25.8189 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2483 1.89964C29.2483 1.98312 28.8679 2.05268 28.3925 2.05268C27.917 2.05268 27.5366 1.98312 27.5366 1.89964C27.5366 1.81617 27.917 1.7466 28.3925 1.7466C28.8679 1.7466 29.2483 1.81617 29.2483 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6847 1.89964C32.6847 1.98312 32.2975 2.05268 31.822 2.05268C31.3466 2.05268 30.9662 1.98312 30.9662 1.89964C30.9662 1.81617 31.3534 1.7466 31.822 1.7466C32.2907 1.7466 32.6847 1.81617 32.6847 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.1142 1.89964C36.1142 1.98312 35.7271 2.05268 35.2516 2.05268C34.7761 2.05268 34.3958 1.98312 34.3958 1.89964C34.3958 1.81617 34.7829 1.7466 35.2516 1.7466C35.7203 1.7466 36.1142 1.81617 36.1142 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5474 1.89964C39.5474 1.98312 39.1602 2.05268 38.6847 2.05268C38.2092 2.05268 37.8289 1.98312 37.8289 1.89964C37.8289 1.81617 38.216 1.7466 38.6847 1.7466C39.1534 1.7466 39.5474 1.81617 39.5474 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9769 1.89964C42.9769 1.98312 42.5897 2.05268 42.1143 2.05268C41.6388 2.05268 41.2584 1.98312 41.2584 1.89964C41.2584 1.81617 41.6456 1.7466 42.1143 1.7466C42.5829 1.7466 42.9769 1.81617 42.9769 1.89964Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 4.93252C43.3639 4.93252 43.296 4.53601 43.296 4.04907C43.296 3.56213 43.3639 3.17258 43.4455 3.17258C43.527 3.17258 43.5949 3.56909 43.5949 4.04907C43.5949 4.52905 43.527 4.93252 43.4455 4.93252Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 8.44635C43.3639 8.44635 43.296 8.04984 43.296 7.5629C43.296 7.07596 43.3639 6.68642 43.4455 6.68642C43.527 6.68642 43.5949 7.08292 43.5949 7.5629C43.5949 8.04288 43.527 8.44635 43.4455 8.44635Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 11.9584C43.3639 11.9584 43.296 11.5619 43.296 11.075C43.296 10.588 43.3639 10.1985 43.4455 10.1985C43.527 10.1985 43.5949 10.595 43.5949 11.075C43.5949 11.5549 43.527 11.9584 43.4455 11.9584Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 15.4713C43.3639 15.4713 43.296 15.0748 43.296 14.5948C43.296 14.1149 43.3639 13.7114 43.4455 13.7114C43.527 13.7114 43.5949 14.1079 43.5949 14.5948C43.5949 15.0818 43.527 15.4713 43.4455 15.4713Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 18.9847C43.3639 18.9847 43.296 18.5882 43.296 18.1082C43.296 17.6282 43.3639 17.2248 43.4455 17.2248C43.527 17.2248 43.5949 17.6213 43.5949 18.1082C43.5949 18.5952 43.527 18.9847 43.4455 18.9847Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 22.4976C43.3639 22.4976 43.296 22.1011 43.296 21.6212C43.296 21.1412 43.3639 20.7377 43.4455 20.7377C43.527 20.7377 43.5949 21.1342 43.5949 21.6212C43.5949 22.1081 43.527 22.4976 43.4455 22.4976Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 26.0101C43.3639 26.0101 43.296 25.6136 43.296 25.1336C43.296 24.6537 43.3639 24.2502 43.4455 24.2502C43.527 24.2502 43.5949 24.6467 43.5949 25.1336C43.5949 25.6206 43.527 26.0101 43.4455 26.0101Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 29.5228C43.3639 29.5228 43.296 29.1333 43.296 28.6463C43.296 28.1594 43.3639 27.7699 43.4455 27.7699C43.527 27.7699 43.5949 28.1594 43.5949 28.6463C43.5949 29.1333 43.527 29.5228 43.4455 29.5228Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 33.0358C43.3639 33.0358 43.296 32.6462 43.296 32.1593C43.296 31.6723 43.3639 31.2828 43.4455 31.2828C43.527 31.2828 43.5949 31.6723 43.5949 32.1593C43.5949 32.6462 43.527 33.0358 43.4455 33.0358Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 36.5492C43.3639 36.5492 43.296 36.1596 43.296 35.6727C43.296 35.1857 43.3639 34.7962 43.4455 34.7962C43.527 34.7962 43.5949 35.1857 43.5949 35.6727C43.5949 36.1596 43.527 36.5492 43.4455 36.5492Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 40.0621C43.3639 40.0621 43.296 39.6725 43.296 39.1856C43.296 38.6987 43.3639 38.3091 43.4455 38.3091C43.527 38.3091 43.5949 38.6987 43.5949 39.1856C43.5949 39.6725 43.527 40.0621 43.4455 40.0621Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4455 43.5746C43.3639 43.5746 43.296 43.185 43.296 42.6981C43.296 42.2111 43.3639 41.8216 43.4455 41.8216C43.527 41.8216 43.5949 42.2111 43.5949 42.6981C43.5949 43.185 43.527 43.5746 43.4455 43.5746Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0011 42.7812H41.897V45.9602H45.0011V42.7812Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 43.2207H0V46.3997H3.10416V43.2207Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0011 0H41.897V3.17901H45.0011V0Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 0.314346H0V3.49335H3.10416V0.314346Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6023 6.87549H8.39772C6.52121 6.87549 5 8.3967 5 10.2732V18.4778C5 20.3543 6.52121 21.8755 8.39772 21.8755H16.6023C18.4788 21.8755 20 20.3543 20 18.4778V10.2732C20 8.3967 18.4788 6.87549 16.6023 6.87549Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 8.87549H11V19.8755H14V8.87549Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 12.8755H7V15.8755H18V12.8755Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.476 25.4696L17.9429 18.92C17.8178 18.873 17.682 18.863 17.5514 18.8911C17.4209 18.9192 17.3011 18.9842 17.2064 19.0785C17.1116 19.1728 17.0458 19.2924 17.0167 19.423C16.9877 19.5537 16.9966 19.6899 17.0425 19.8157L23.6104 37.4214C23.6614 37.5577 23.7535 37.6747 23.874 37.7561C23.9945 37.8374 24.1372 37.8791 24.2824 37.8752C24.4276 37.8714 24.568 37.8222 24.684 37.7346C24.8 37.647 24.8859 37.5252 24.9296 37.3864L26.8071 31.2636L33.1727 37.4913C33.3034 37.6217 33.4803 37.6948 33.6647 37.6948C33.8491 37.6948 34.026 37.6217 34.1568 37.4913L35.797 35.8469C35.927 35.7158 36 35.5385 36 35.3536C36 35.1687 35.927 34.9914 35.797 34.8603L29.4525 28.6605L35.476 26.7922C35.6131 26.7446 35.732 26.6553 35.8162 26.5368C35.9004 26.4183 35.9457 26.2764 35.9457 26.1309C35.9457 25.9854 35.9004 25.8435 35.8162 25.725C35.732 25.6065 35.6131 25.5172 35.476 25.4696Z",
			fill: "black"
		})
	]
});
export default SvgNoResource;
